import {Fragment} from 'react'
import {useLayout, usePageData} from '../../../core'
import {Link, useLocation} from 'react-router-dom'
import clsx from 'clsx'
import {useHeaderBreadcrumb} from '../../../../layout/core'

function HeaderDefaultTitle() {
  const location = useLocation()
  let currentLink = ''
  let unwantedTitles = [
    'Units',
    'Physical Events',
    'Crafted',
    'Trays',
    'Matter And Nature',
    'Creatures And Life',
    'Fun Science',
    'Report',
  ]

  function capitalizeFirstLetter(sentence: string) {
    return sentence
      .replace(/-/g, ' ')
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  const crumbs = location.pathname
    .split('/')
    .filter((crumb) => crumb !== '')
    .map((crumb, index, array) => {
      const isLastCrumb = index === array.length - 1
      currentLink = currentLink + `/${crumb}`

      if (unwantedTitles.includes(capitalizeFirstLetter(crumb))) {
        return null
      }

      return (
        <Fragment key={index}>
          {isLastCrumb ? (
            <li className='breadcrumb-item text-dark'>{capitalizeFirstLetter(crumb)}</li>
          ) : (
            <>
              <li className='breadcrumb-item text-muted'>
                <Link className='text-muted text-hover-primary' to={currentLink}>
                  {capitalizeFirstLetter(crumb)}
                </Link>
              </li>
              <li className='breadcrumb-item'>
                <span className='bullet bg-gray-400 w-5px h-2px' />
              </li>
            </>
          )}
        </Fragment>
      )
    })

  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config, classes} = useLayout()
  const {changeTitle, changeBeforeTitle, returnPath} = useHeaderBreadcrumb()

  if (changeBeforeTitle.length > 0) {
    if (pageBreadcrumbs && pageBreadcrumbs.length > 3) {
      pageBreadcrumbs[pageBreadcrumbs.length - 2].title = changeBeforeTitle
    }
  }

  return (
    <div
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx(
        'page-title d-flex align-items-center flex-wrap me-3',
        classes.pageTitle.join(' ')
      )}
    >
      {/* begin::Title */}
      {pageTitle && (
        <h1 className='d-flex align-items-center text-dark fw-bolder my-1 fs-3'>
          {pageTitle}
          {pageDescription && config.pageTitle && config.pageTitle.description && (
            <>
              {/* begin::Separator */}
              <span className='h-20px border-gray-200 border-start ms-3 mx-2'></span>
              {/* end::Separator */}

              <small className='text-muted fs-7 fw-bold my-1 ms-1'>{pageDescription}</small>
            </>
          )}
        </h1>
      )}
      {/* end::Title */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <>
            {/* begin::Separator */}
            <span className='h-20px border-gray-200 border-start mx-3'></span>
            {/* end::Separator */}
            <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1'>
              <li className='breadcrumb-item text-muted'>
                <Link className='text-muted text-hover-primary' to={'/dashboard'}>
                  Home
                </Link>
              </li>
              <li className='breadcrumb-item'>
                <span className='bullet bg-gray-400 w-5px h-2px' />
              </li>
              {crumbs}
            </ul>
            {/*}
            <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <Fragment key={`${item.path}${index}`}>
                  {item.isSeparator ? (
                    <li className='breadcrumb-item'>
                      <span className='bullet bg-gray-400 w-5px h-2px'></span>
                    </li>
                  ) : (
                    <>
                      {item.isActive ? (
                        <li className='breadcrumb-item text-dark'>{item.title}</li>
                      ) : (
                        <li className='breadcrumb-item text-muted'>
                          <Link
                            to={
                              item.title.includes('Home') || item.title.includes('Tray')
                                ? item.path
                                : '/' + returnPath
                            }
                            state={{path: returnPath}}
                            className='text-muted text-hover-primary'
                          >
                            {item.title}
                          </Link>
                        </li>
                      )}
                    </>
                  )}
                </Fragment>
              ))}
              <li className='breadcrumb-item text-dark'>{changeTitle || pageTitle}</li>
            </ul>
                          {*/}
          </>
        )}
    </div>
  )
}

export default HeaderDefaultTitle
